module.exports = __webpack_public_path__ + "static/logo-countUsIn-c3770b40942a5ab7c0ce71da68bda836.png";